// extracted by mini-css-extract-plugin
export default {"container":"MoviesDetails_container__Udhwd","col":"MoviesDetails_col__cS0s9","imgCard":"MoviesDetails_imgCard__HlG8R"};